import React, { FunctionComponent, useState } from 'react';
import { Icon, Pill } from 'rs-emd-ui-atoms';
import { ProductInfoModal } from '..';
import styles from './product-info-pill-component.module.scss';

export type ProductInfoPillProps = {
  title?: string | null;
  message?: string | null;
  modalCTA?: string | null;
  modalTitle?: string | null;
  modalMessage?: string | null;

  type: 'default' | 'plp' | 'barred' | 'restricted';
};

//TODO: remove as no longer in user due to EMD-351
export const ProductInfoPill: FunctionComponent<ProductInfoPillProps> = (props: ProductInfoPillProps) => {
  let [isProductInfoModalOpen, setIsProductInfoModalOpen] = useState(false);

  return (
    <div className={styles['product-info-pill-container']}>
      <Pill class={`${styles['product-info-pill']} ${styles[`${props.type}-pill`]}`}>
        <div className={styles['title-area']}>
          <div className={`${styles.title} ${props.type !== 'barred' && props.type !== 'restricted' ? styles['title-icon'] : ''}`}>
            {props.type !== 'barred' && props.type !== 'restricted' && <Icon name='warning' />}
            <p className={styles['title-text']}>{props.title}</p>
          </div>
          <p className={`link ${styles.link}`} onClick={() => setIsProductInfoModalOpen(true)}>
            {props.modalCTA}
          </p>
        </div>
        {props.message && props.message !== '' && <p className={styles.message}>{props.message}</p>}
      </Pill>

      {isProductInfoModalOpen && (
        <ProductInfoModal title={props.modalTitle} message={props.modalMessage} closeCallback={() => setIsProductInfoModalOpen(false)} />
      )}
    </div>
  );
};

ProductInfoPill.defaultProps = {
  type: 'default',
};
